import { Time } from 'src/store/models/timetable/index.js'
import Monitors from 'src/api/monitors.js'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const defaultState = () => ({
  school_name: '',
  dates: [],
  selectedDate: 0,
  substitutionInterval: 5,
  loadingBarTime: 0,
  loadingId: null,
  loadingText: '',
  parts: [],
  monitor: {
    options: {
      has_brand: null,
      has_loading: true,
      has_daily_comment: true,
      has_time: true
    },
    css_class: 'd-flex flex-row ',
    style: ''
  },
  windowSize: null
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_DATES (state, dates) {
    state.dates = dates
  },
  SET_SELECTED_DATE (state, i) {
    state.selectedDate = i
  },
  NEXT_SELECTED_DAY (state) {
    state.selectedDate = state.dates.length <= state.selectedDate + 1 ? 0 : state.selectedDate + 1
  },
  SET_LOADING_BAR_TIME (state, time) {
    state.loadingBarTime = time
  },
  SET_LOADING_ID (state, id) {
    state.loadingId = id
  },
  SET_WINDOW_SIZE (state, size) {
    state.windowSize = size
  },
  SET_PARTS (state, parts) {
    state.parts = parts
  },
  SET_LOADING_TEXT (state, text) {
    state.loadingText = text
  },
  SET_MONITOR (state, monitor) {
    const layout = monitor.layout
    state.monitor = {
      options: {
        // has_brand: layout.has_brand,
        // has_loading: layout.has_loading,
        // has_daily_comment: layout.has_daily_comment,
        // has_time: layout.has_time
      },
      css_class: layout.css_classes,
      style: layout.style
    }
  }
}

export const actions = {
  saveMonitorAuthToken ({ _ }, authToken) {
    GlobalPrototypes.axios.defaults.headers.Authorization = `Bearer ${authToken}`
  },
  async fetchMonitorData ({ commit }) {
    commit('SET_LOADING_TEXT', 'lade Basisdaten...')
    const beginsAt = GlobalPrototypes.router.currentRoute.value.query.begins_at

    const res = await Monitors.getMonitorSingle({
      params: {
        substitution_date: beginsAt || null,
        new_version: 1
      },
      timeout: 5 * 60 * 1000
    })

    const data = res.data
    const parts = data.parts

    commit('SET_LOADING_TEXT', 'verarbeite Basisdaten...')
    commit('SET_MONITOR', data)

    commit('SET_LOADING_TEXT', 'Stunden werden verarbeitet...')
    commit('SET_PARTS', parts)

    const vpData = parts.find(part => ['TEACHERS', 'GRADES'].includes(part.type))

    if (!vpData || !vpData.data || !vpData.data.times) return parts
    Time.insertOrUpdate({ data: vpData.data.times })

    return parts
  }
}
